function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, computed, watch, ref } from "vue";
import _ from "lodash";
import { playTurboHostList } from "@/config/host";
import { NODE_ENV } from "@com/config/env";
import { fellAllAdvertisers } from "@/api/demand/demand";
import { copyPSProject } from "@/api/ps/manage";
import { loginAdvertiser } from "@/api/advertiser/manage";
export default defineComponent({
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        params: {
            type: Object,
            required: true
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var remoteBase = function remoteBase(query) {
            remoteLoading.value = true;
            fellAllAdvertisers({
                keyword: query
            }).then(function(res) {
                remoteLoading.value = false;
                options.value = (_.get(res, "data.data.list") || []).filter(function(item) {
                    // mws_account_type 1内部 2普通
                    if (item.mws_account_type === 1) {
                        item["value"] = item.id;
                        item["label"] = item.name;
                        return item;
                    }
                });
            }).catch(function() {
                options.value = [];
                remoteLoading.value = false;
            });
        };
        var handleClose = function handleClose() {
            if (!loading.value) {
                emit("update:visible", false);
            }
        };
        var loading = ref(false);
        var remoteLoading = ref(false);
        var options = ref([]);
        var model = ref({
            adv_id: 9432
        });
        var dialogVisible = computed({
            get: function() {
                return props.visible;
            },
            set: function(val) {
                emit("update:visible", val);
            }
        });
        var playTurboUrl = computed(function() {
            // @ts-ignore
            return "".concat(playTurboHostList[NODE_ENV], "/#/auth");
        });
        watch(function() {
            return props.visible;
        }, function(val) {
            if (val) {
                model.value.adv_id = 9432;
                remoteBase("idg");
            }
        }, {
            immediate: true
        });
        function handleSubmit() {
            return _handleSubmit.apply(this, arguments);
        }
        function _handleSubmit() {
            _handleSubmit = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            loading.value = true;
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return copyPSProject(_objectSpreadProps(_objectSpread({}, props.params), {
                                adv_id: model.value.adv_id
                            }));
                        case 4:
                            res = _ctx.sent;
                            if (!(res.data.code === 0)) {
                                _ctx.next = 8;
                                break;
                            }
                            _ctx.next = 8;
                            return login("ps", res.data.data);
                        case 8:
                            _ctx.next = 13;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](1);
                            console.log("error", _ctx.t0);
                        case 13:
                            _ctx.prev = 13;
                            loading.value = false;
                            handleClose();
                            return _ctx.finish(13);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        10,
                        13,
                        17
                    ]
                ]);
            }));
            return _handleSubmit.apply(this, arguments);
        }
        function login(source_project, source_project_id) {
            return _login.apply(this, arguments);
        }
        function _login() {
            _login = _asyncToGenerator(regeneratorRuntime.mark(function _callee(source_project, source_project_id) {
                var newTab, close, res, token;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            newTab = window.open("about:blank");
                            close = function() {
                                if (newTab) {
                                    newTab.close();
                                    newTab = null;
                                }
                            };
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return loginAdvertiser({
                                id: model.value.adv_id
                            });
                        case 5:
                            res = _ctx.sent;
                            if (res.data.code === 0) {
                                token = _.get(res, "data.data.token") || "";
                                // @ts-ignore
                                newTab.location.href = "".concat(playTurboUrl.value, "?token=").concat(token, "&source_project=").concat(source_project, "&source_project_id=").concat(source_project_id);
                                newTab = null;
                            } else {
                                close();
                            }
                            _ctx.next = 12;
                            break;
                        case 9:
                            _ctx.prev = 9;
                            _ctx.t0 = _ctx["catch"](2);
                            close();
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        9
                    ]
                ]);
            }));
            return _login.apply(this, arguments);
        }
        return {
            loading: loading,
            remoteLoading: remoteLoading,
            dialogVisible: dialogVisible,
            options: options,
            model: model,
            remoteBase: remoteBase,
            handleClose: handleClose,
            handleSubmit: handleSubmit
        };
    }
});
